import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { forwardRef, useRef, useId } from "react";
import './index.css';const clamp = (num, min = 0, max = 100) => Math.min(Math.max(num ?? 0, min), max);
function getAriaAttributes(type = "progress", progress, loadingText) {
  if (type === "progress") {
    return {
      role: "progressbar",
      "aria-label": `${loadingText ?? "loading progress"}`,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": progress
    };
  }
  return {
    role: "progressbar",
    "aria-label": `${loadingText ?? "loading..."}`,
    "aria-busy": true
  };
}
const LinearLoadingIndicator = forwardRef(
  ({
    progress,
    type = "progress",
    variant = "default",
    loadingText,
    className,
    ...props
  }, ref) => {
    const progressBarRef = useRef(null);
    const id = useId();
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: `loadingIndicatorContainer${className ? ` ${className}` : ""}`,
        "data-stb-loading-indicator-linear": "true",
        "data-component-info": "pretzel-loading-indicator-linear",
        children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              ...getAriaAttributes(type, progress, loadingText),
              ...props,
              ref,
              className: "indicatorTrack indicatorBase",
              children: type === "indeterminate" ? /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    id: `${id}-increase-bar`,
                    className: `progressBar materialBar ${variant}`
                  }
                ),
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    id: `${id}-decrease-bar`,
                    className: `materialBarDecrease materialBar progressBar ${variant}`
                  }
                )
              ] }) : /* @__PURE__ */ jsx(
                "div",
                {
                  ref: progressBarRef,
                  className: `indicatorTrack progressBar ${variant}`,
                  style: { width: `${clamp(progress)}%` }
                }
              )
            }
          ),
          loadingText && /* @__PURE__ */ jsx("p", { className: "font-body loadingText", children: loadingText })
        ]
      }
    );
  }
);
export {
  LinearLoadingIndicator,
  LinearLoadingIndicator as default
};
